
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/embed/[widgetId]",
      function () {
        return require("private-next-pages/embed/[widgetId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/embed/[widgetId]"])
      });
    }
  